import * as http from './Http'

const SUPER = 'super'

export const search = query => http.get(`${SUPER}/portals/filter?${query}`)
export const getfilterOptions = () => http.get(`${SUPER}/portals/getFilterOptions`)

export const updateConfig = data => http.put(`${SUPER}/portals/${data.id}/update/config`, data)
export const restartPortal = id => http.get(`${SUPER}/portals/${id}/restart`)
export const removePortal = id => http.del(`${SUPER}/portals/${id}/delete`)
export const networkDetails = id => http.get(`${SUPER}/portals/${id}/network-details`)

export const getPortal = id => http.get(`${SUPER}/portals/${id}/detail`)
